    <template>
    <div class="c-dropdown c-dropdown-container" v-bind:style="{top: posy + 'px', left: posx + 'px', display: toggled ? 'inline-block' : 'none', opacity: show ? 1 : 0}" v-bind:class="{'list' : currentComponent === 'list', 'expanded' : expanded}">
        <div class="background" v-on:scroll="PreventScroll($event)" v-on:click="Toggle()"></div>
        <div class="header" v-if="header">
            <div class="label">{{header}}</div>
        </div>
        <div v-if="currentComponent === 'list'" class="items" v-bind:class="{'icons-left': iconsLeft}">
            <div class="item" v-for="(item, indexI) in items" :key="indexI" v-bind:class="{'selected': item.selected}" v-on:click="SelectItem($event, item)" v-bind:style="item.styles">
                <i v-if="item.toggled !== undefined && item.toggled" class="fas fa-check-circle checkbox true" v-bind:style="{color: item.color}"></i>
                <i v-if="item.toggled !== undefined && !item.toggled" class="fas fa-circle checkbox false" v-bind:style="{color: item.color}"></i>
                <div class="label">{{item.label}}</div>
            </div>
        </div>
        <component v-if="currentComponent !== 'list'" v-bind:is="currentComponent" :eventProp="eventProp" ref="component"></component>
        <div class="pointer up" v-bind:style="{left: pointerOffset + 'px', display: !pointerDirection || pointerDirection === 0 ? 'inline-block' : 'none'}"></div>
        <div class="pointer right" v-bind:style="{top: pointerOffset + 'px', display: pointerDirection === 1 ? 'inline-block' : 'none'}"></div>
        <div class="pointer down" v-bind:style="{left: pointerOffset + 'px', display: pointerDirection === 2 ? 'inline-block' : 'none'}"></div>
        <div class="pointer left" v-bind:style="{top: pointerOffset + 'px', display: pointerDirection === 3 ? 'inline-block' : 'none'}"></div>
    </div>
</template>

<script>
    import searchbar from './searchbar.vue'
    import datepicker from './datepicker.vue'
    import imagecrop from './imagecrop.vue'
    import timebar from '../testroster/TimeBar.vue'
    import datafill from './datafill.vue'
    export default {
        name: 'dropdowncontainer',
        components: {
            searchbar,
            datepicker,
            imagecrop,
            datafill,
            timebar,
        },
        data(){
            return{
                searchbarItems: {items: [], input: ''},
                el: null,
                elRelative: null,
                defaultSettings: {
                    pointerDirection: 0,
                    pointerOffset: 15,
                },
                selectedItem: {},
                items: [],
                toggled: false,
                posx: 0,
                remainAfterSelect: false,
                posy: 0,
                pointerDirection: 0,
                pointerOffset: 0,
                onceSelected: function($event,item){},
                parentCallback: function(){},
                currentComponent: '',
                iconsLeft: false,
                expanded: false,
                eventProp: {},
                header: null,
                show: false,
            }
        },
        created () {
            window.addEventListener("resize", this.Reposition);
            var view = this;
            requestAnimationFrame(function(){
                $(view.$el).appendTo('body');
            });
        },
        mounted (){
        },
        destroyed () {
            window.removeEventListener("resize", this.Reposition);
        },
        props:{
            dropdown: Object,
        },
        methods: {
            PreventScroll($event){
                $event.preventDefault();
            },
            Reposition(){
                var boxContainer = this.$el.getBoundingClientRect();
                var view = this;
                if(this.elRelative){
                    requestAnimationFrame(function(){
                        var boxRelative = view.elRelative.getBoundingClientRect();
                        var boxPointer = null;
                        boxContainer = view.$el.getBoundingClientRect();

                        var widthTotal = window.innerWidth;
                        var heightTotal = window.innerHeight;
                        var posx = 0;
                        var posy = 0;
                        var widthContainer = boxContainer.width;
                        var heightContainer = boxContainer.height;
                        var offsetFromPointer = (boxContainer.width * .5); //15;
                        if(view.pointerDirection === 0){
                            boxPointer = $(view.$el).find('.pointer.up')[0].getBoundingClientRect();
                            view.pointerOffset = (boxContainer.width * .5) - (boxPointer.width * .5);
                            posx = (boxRelative.left  + (boxRelative.width * .5)) - (boxContainer.width * .5);
                            var pointerPositionRelative = boxPointer.top - boxContainer.top;
                            posy = boxRelative.bottom + (15);
                        }
                        if(view.pointerDirection === 1){
                            boxPointer = $(view.$el).find('.pointer.right')[0].getBoundingClientRect();
                            posx = boxRelative.left - offsetFromPointer - boxContainer.width;
                            var pointerPositionRelative = boxPointer.top - boxContainer.top;
                            posy = boxRelative.top + (boxRelative.height / 2) - pointerPositionRelative;
                        }
                        if(view.pointerDirection === 2){
                            boxPointer = $(view.$el).find('.pointer.down')[0].getBoundingClientRect();
                            posx = boxRelative.right + offsetFromPointer;
                            var pointerPositionRelative = boxPointer.top - boxContainer.top;
                            posy = boxRelative.top + (boxRelative.height / 2) - pointerPositionRelative;
                        }
                        if(view.pointerDirection === 3){
                            boxPointer = $(view.$el).find('.pointer.left')[0].getBoundingClientRect();
                            posx = boxRelative.right + 15;
                            var pointerPositionRelative = boxPointer.top - boxContainer.top;
                            posy = (boxRelative.top  + (boxRelative.height * .5)) - (boxContainer.height * 0.5) - ((boxPointer.top + (boxPointer.height * 1.5)) - (boxPointer.top + (boxContainer.height * 0.5)));
                        }
                        view.posx = posx;
                        view.posy = posy;
                        //view.pointerDirection = pointerDirection;
                        view.$forceUpdate();
                        view.show = true;
                    });
                } else {
                    this.posx = boxContainer.left + this.offsetx;
                    this.posy = boxContainer.bottom + this.offsety;
                }
            },
            Init(config){
                this.header = '';
                this.expanded = false;
                for(var x in this.defaultSettings)
                {
                    this[x] = this.defaultSettings[x];
                }
                for(var y in config)
                {
                    if(Object.keys(this).indexOf(y) > -1) this[y] = config[y];
                }
                var view = this;
                requestAnimationFrame(function(){
                    if(config.currentComponent === 'datafill') view.$refs.component.Init(config.header, config.data, config.onceSelected, view);
                    view.Reposition();
                });
                this.items = config.items;
                this.Toggle();
            },
            SelectItem($event, item){
                var event = $event;
                var dropdown = this;
                this.selectedItem = item;
                this.toggled = this.remainAfterSelect;
                if(this.onceSelected){
                    this.onceSelected($event, item, dropdown);
                }
                if(item.onceSelected){
                    item.onceSelected($event, item, dropdown);
                }
                this.$forceUpdate();
            },
            loadItems(itemsNew){
                this.items = itemsNew;
            },
            Toggle(val){
                if(val === undefined) this.toggled = !this.toggled;
                else this.toggled = val;
                if(!this.toggled) this.show = false;
                var view = this;
                requestAnimationFrame(function(){
                    if(view.elRelative) return;
                    var box = view.$el.getBoundingClientRect();
                    if(view.pointerDirection == 1)
                    {
                        if(view.pointerOffset > box.height - 20) view.pointerOffset = box.height - 20;
                        if(view.pointerOffset < 20) view.pointerOffset = 20;
                    } else if(view.pointerDirection == 3)
                    {
                        if(view.pointerOffset > box.height - 20) view.pointerOffset = box.height - 20;
                        if(view.pointerOffset < 20) view.pointerOffset = 20;
                    }else if(view.pointerDirection == 2)
                    {
                        if(view.pointerOffset > box.width - 20) view.pointerOffset = box.width - 20;
                        if(view.pointerOffset < 20) view.pointerOffset = 20;
                    } else {
                       if(view.pointerOffset > box.width - 20) view.pointerOffset = box.width - 20;
                       if(view.pointerOffset < 20) view.pointerOffset = 20;
                   }
               });
                requestAnimationFrame(function(){
                    if(view.currentComponent === 'timebar') {
                        if(view.toggled) view.$refs.component.Init();
                        else view.$refs.component.$refs.overlay.toggled = false;
                    }
                    if(view.currentComponent === 'datafill') {
                        if(!view.toggled) view.$refs.component.entries = [];
                    }
                });
                if(this.parentCallback) this.parentCallback();
            },
        }
    }
</script>

<style scoped>
    .c-dropdown-container{
        z-index: 100;
        background: var(--bg);
        box-shadow: 4px 4px 8px 0px rgba(0,0,0,0.2);
    }
    .c-dropdown-container .background{
        position: fixed;
        top: 0;
        left: 0;
        width: 100vw;
        height: 100vh;
        z-index: -1;
    }
    .c-dropdown-container.list{
        background: var(--contrast-1);
    }
    .nightmode .dropdown-container{
        background: var(--sub-menu);
    }
.c-dropdown .pointer{
    position: absolute;
    top: -7px;
    left: 225px;
    border-left: 7px solid transparent;
    border-right: 7px solid transparent;
    border-bottom: 7px solid #959595;
}
.c-dropdown:not(.list) .pointer:before{
    content:'';
    position: absolute;
    top: 2px;
    left: -5px;
    border-left: 5px solid transparent;
    border-right: 5px solid transparent;
    border-bottom: 5px solid #ebebeb;
}
.c-dropdown .pointer.up{
    top: -7px;
    left: 15px;
    border-left: 7px solid transparent;
    border-right: 7px solid transparent;
    border-bottom: 7px solid var(--contrast-2);
}
.c-dropdown:not(.list) .pointer.up:before{
    top: 2px;
    left: -5px;
    border-left: 5px solid transparent;
    border-right: 5px solid transparent;
    border-bottom: 5px solid white;
}
.c-dropdown .pointer.right{
    left: initial;
    right: -7px;
    right: -19px;
    top: 15px;
    border-top: 7px solid transparent;
    border-bottom: 7px solid transparent;
    border-left: 7px solid var(--contrast-2);
}
.c-dropdown:not(.list) .pointer.right:before{
    left: initial;
    top: -5px;
    border-top: 5px solid transparent;
    border-bottom: 5px solid transparent;
    border-left: 5px solid white;
}
.c-dropdown .pointer.down{
    top: initial;
    border-bottom: none;
    bottom: -7px;
    left: 15px;
    border-left: 7px solid transparent;
    border-right: 7px solid transparent;
    border-top: 7px solid var(--contrast-2);
}
.c-dropdown:not(.list) .pointer.down:before{
    top: initial;
    border-bottom: none;
    bottom: 2px;
    left: -5px;
    border-left: 5px solid transparent;
    border-right: 5px solid transparent;
    border-top: 5px solid white;
}
.c-dropdown .pointer.left{
    left: -14px;
    top: 15px;
    border-top: 7px solid transparent;
    border-bottom: 7px solid transparent;
    border-right: 7px solid var(--contrast-2);
}
.c-dropdown:not(.list) .pointer.left:before{
    left: -4px;
    top: -6px;
    border-top: 6px solid transparent;
    border-bottom: 6px solid transparent;
    border-right: 6px solid white;
}
.nightmode .c-dropdown:not(.list) .pointer{
    border-left: 7px solid transparent;
    border-right: 7px solid transparent;
    border-bottom: 7px solid #959595;
}
.nightmode .c-dropdown:not(.list) .pointer:before{
    border-left: 5px solid transparent;
    border-right: 5px solid transparent;
    border-bottom: 5px solid #ebebeb;
}
    .nightmode .c-dropdown:not(.list) .pointer.up{
        border-left: 7px solid transparent;
        border-right: 7px solid transparent;
        border-bottom: 7px solid var(--sub-menu);
    }
    .nightmode .c-dropdown:not(.list) .pointer.up:before{
        border-left: 5px solid transparent;
        border-right: 5px solid transparent;
        border-bottom: 5px solid var(--sub-menu);
    }
    .nightmode .c-dropdown:not(.list) .pointer.right{
        border-top: 7px solid transparent;
        border-bottom: 7px solid transparent;
        border-left: 7px solid var(--sub-menu);
    }
    .nightmode .c-dropdown:not(.list) .pointer.right:before{
        border-top: 5px solid transparent;
        border-bottom: 5px solid transparent;
        border-left: 5px solid var(--sub-menu);
    }
    .nightmode .c-dropdown:not(.list) .pointer.down{
        border-left: 7px solid transparent;
        border-right: 7px solid transparent;
        border-top: 7px solid var(--sub-menu);
    }
    .nightmode .c-dropdown:not(.list) .pointer.down:before{
        border-left: 5px solid transparent;
        border-right: 5px solid transparent;
        border-top: 5px solid var(--sub-menu);
    }
    .nightmode .c-dropdown:not(.list) .pointer.left{
        border-top: 7px solid transparent;
        border-bottom: 7px solid transparent;
        border-right: 7px solid var(--sub-menu);
    }
    .nightmode .c-dropdown:not(.list) .pointer.left:before{
        border-top: 6px solid transparent;
        border-bottom: 6px solid transparent;
        border-right: 6px solid var(--sub-menu);
    }
    .nightmode .c-dropdown.expanded .pointer.up{
        border-left: 7px solid transparent;
        border-right: 7px solid transparent;
        border-bottom: 7px solid var(--sub-menu);
    }
    .nightmode .c-dropdown.expanded .pointer.up:before{
        border-left: 5px solid transparent;
        border-right: 5px solid transparent;
        border-bottom: 5px solid var(--bg);
    }
    .nightmode .c-dropdown.expanded .pointer.right{
        border-top: 7px solid transparent;
        border-bottom: 7px solid transparent;
        border-left: 7px solid var(--sub-menu);
    }
    .nightmode .c-dropdown.expanded .pointer.right:before{
        border-top: 5px solid transparent;
        border-bottom: 5px solid transparent;
        border-left: 5px solid var(--bg);
    }
    .nightmode .c-dropdown.expanded .pointer.down{
        border-left: 7px solid transparent;
        border-right: 7px solid transparent;
        border-top: 7px solid var(--sub-menu);
    }
    .nightmode .c-dropdown.expanded .pointer.down:before{
        border-left: 5px solid transparent;
        border-right: 5px solid transparent;
        border-top: 5px solid var(--bg);
    }
    .nightmode .c-dropdown.expanded .pointer.left{
        border-top: 7px solid transparent;
        border-bottom: 7px solid transparent;
        border-right: 7px solid var(--sub-menu);
    }
    .nightmode .c-dropdown.expanded .pointer.left:before{
        border-top: 6px solid transparent;
        border-bottom: 6px solid transparent;
        border-right: 6px solid var(--bg);
    }
.item {
    position: relative;
    display: block;
    height: 20px;
    text-align: left;
    font-size: 11px;
    padding: 0 10px;
    cursor: pointer;
    -webkit-transition: .2s;
    transition: .2s;
    background: var(--contrast-1);
    overflow: hidden;
    color: var(--contrast-4);
}


.container {
    overflow:hidden;
}

.item * {
    pointer-events: none;
    float: left;
    min-height: 15px;
    margin-top: -3px;
    overflow: hidden;
    line-height: 200%;
}

.item .fas {
    margin-right: 10px;
}

.item *:first-child {
    margin-top: 1px;
}

.item:nth-child(even) {
    background: var(--contrast-2);
}

.item:hover,.item.selected {
    background: #6d8d23;
    color: var(--bg);
}
.item:hover .label,.item.selected .label{
    color: var(--bg);
}

.show {
    display: inline-block;
}

.checkbox {
    float: right;
    margin-left: 5px;
    top: 0;
    bottom: 0;
    margin-right: -5px !important;
    right: 5px;
    margin-top: 4px !important;
    min-height: initial;
    height: 12px;
    width: 12px;
    font-size: 12px;
    line-height: 100%;
    border-radius: 100px;
}

.icons-left .checkbox {
    float: left;
    margin-right: 5px !important;
    margin-left: -5px !important;
    left: 5px;
    right: initial;
}

.checkbox.true {
    color: #6d8d23;
}

.checkbox.false {
    color: rgba(0, 0, 0, 0);
    background: var(--contrast-2);
    box-shadow: none;
    border-radius: 100px;
}

.item:nth-child(even) .checkbox.false {
    background: var(--contrast-1);
}

.searchbar {
    width: 180px;
    margin: 0 10px;
}

.searchbar .items {
    width: 180px;
}

    .c-dropdown-container.expanded {
        padding: 30px;
        background: white;
    }
    .nightmode .c-dropdown-container.expanded {
        background: var(--bg);
    }

    .expanded .item{
        margin-left: 35px;
        background-color: #6d8d23;
        padding: 4px 10px;
        border-radius: 20px;
        color: #fff;
        cursor: pointer;
        -webkit-transition: background-color 1000ms linear;
        transition: background-color 1000ms linear;
        -webkit-transition: color 1000ms linear;
        transition: color 1000ms linear;
        height: 26px;
        margin-bottom: 5px;
        margin-left: 0;
        line-height: 100%;
    }

    .expanded .item .label{
        color: white;
        font-weight: 400;
        font-size: 16px;
        line-height: 150%;
        margin-left: 30px;
    }

    .expanded .item .checkbox{
        width: 18px;
        height: 18px;
        color: white;
        font-size: 18px;
        margin: 0 !important;
        /*background: rgb(255,255,255);
        background: radial-gradient(circle,  rgba(255,255,255,1) 0%, rgba(255,255,255,1) 60%, rgba(255,255,255,0) 60%, rgba(255,255,255,0) 100%);*/
    }

    .expanded .header{
        position: relative;
        display: inline-block;
        margin-bottom: 20px;
    }

    .header .label{
       padding-left: 30px;
    }
    .expanded .header .label{
        box-shadow: inset 0 -1px 0 0px #ebebeb;
        font-size: 20px;
        margin-right: 60px;
    }

</style>
